<template>
  <div class="w-100">
    <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_INVOICES)"
        :canDelete="checkClaim(CAN_DELETE_INVOICES)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :navigationField="'partNumber'"
        :handleRowClick="onRowClick"
      />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import { SORT_ORDER, GRID_ID } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent
  },
  props: {
    invoiceId: {
      type:  [Number, String],
      default: 0,
    },
    showAllGridRows: {
      type: [Boolean],
      default: false,
    },
  },
  data: () => ({
    selectedRowItemId: 0,
    gridId: GRID_ID.INVOICES_LINES,
    fields: gridFields,
  }),
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapState('invoiceLines', ['invoiceLines']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      if (this.invoiceLines == undefined || !this.invoiceLines.length) return [];
      return this.invoiceLines.map((invoiceLine) => ({ ...invoiceLine, selected: invoiceLine.id === this.selectedRowItemId }));
    },
  },
  methods: {
    ...mapActions('invoiceLines', ['getInvoiceLines']),
    ...mapMutations('invoiceLines', ['setItem']),
    ...mapActions('account', ['saveGridSettings']),
    onEdit(data) {
      this.$emit('showEdit', data);
    },
    onDelete(id) {
      this.$emit('showDelete', id);
    },
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
    },
  },
  watch: {
    invoiceId() {
      if(this.invoiceId) {
        this.getInvoiceLines(this.invoiceId);
      } else {
        this.setItem({ resource: 'invoiceLines', payload: [] });
      }
    },
    invoiceLines() {
      this.selectedRowItemId = this.setSelectedRowId(this.invoiceLines,this.selectedRowItemId);
    },
    selectedRowItemId(newVal) {
      this.invoiceLines.find(invoiceLine => console.log('invoiceLine ::', invoiceLine.id));
      const selectedRow = this.invoiceLines.find(invoiceLine => invoiceLine.id === newVal);
      if(selectedRow != undefined) {
        this.$emit('selectedInvoiceLine', selectedRow);
      }
    },
  },
  mounted() {
    this.setItem({ resource: 'invoiceLines', payload: [] });
    if(this.invoiceId) {
      this.getInvoiceLines(this.invoiceId);
    }
  }
};
</script>
